import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[top-bar-host]'
})
export class TopBarDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
